import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { actions } from '../redux/ProductReducer';
import { Box, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import ProductListItem from '../components/ProductListItem/ProductListItem';

// To be moved into product metadata
const ALLOWED_BUTTONS = {
  TRAV: {
    'Scheme Management': {
      url: 'insurers',
      type: 'link',
    },
    Definitions: {
      url: 'definitions',
      type: 'link',
    },
    Declaration: {
      url: 'declaration',
      type: 'link',
    },
    'Static Documents': {
      url: 'documents',
      type: 'link',
    },
    'Dynamic Documents': {
      url: 'dynamic-documents',
      type: 'link',
    },
    'Ancillary Scheme Documents': {
      url: 'ancillary-scheme-documents',
      type: 'link',
    },
    'Document Pack': {
      url: 'document-pack',
      type: 'link',
    },
    'Admin Fees': {
      url: 'admin-fees',
      type: 'link',
    },
    'Import Schemes': {
      url: '',
      type: 'SchemesImportModal',
    },
  },
  HCP: {
    'Scheme Management': {
      url: 'schemes',
      type: 'link',
    },
    Definitions: {
      url: 'definitions',
      type: 'link',
    },
    Declaration: {
      url: 'declaration',
      type: 'link',
    },
    'Static Documents': {
      url: 'documents',
      type: 'link',
    },
    'Dynamic Documents': {
      url: 'dynamic-documents',
      type: 'link',
    },
    'Document Pack': {
      url: 'document-pack',
      type: 'link',
    },
  },
  PA: {
    'Scheme Management': {
      url: 'schemes',
      type: 'link',
    },
    Definitions: {
      url: 'definitions',
      type: 'link',
    },
    Declaration: {
      url: 'declaration',
      type: 'link',
    },
    'Static Documents': {
      url: 'documents',
      type: 'link',
    },
    'Dynamic Documents': {
      url: 'dynamic-documents',
      type: 'link',
    },
    'Document Pack': {
      url: 'document-pack',
      type: 'link',
    },
  },
  CC: {
    'Scheme Management': {
      url: 'schemes',
      type: 'link',
    },
    Definitions: {
      url: 'definitions',
      type: 'link',
    },
    Declaration: {
      url: 'declaration',
      type: 'link',
    },
    'Static Documents': {
      url: 'documents',
      type: 'link',
    },
    'Dynamic Documents': {
      url: 'dynamic-documents',
      type: 'link',
    },
    'Document Pack': {
      url: 'document-pack',
      type: 'link',
    },
  },
  SC: {
    'Scheme Management': {
      url: 'schemes',
      type: 'link',
    },
    Definitions: {
      url: 'definitions',
      type: 'link',
    },
    Declaration: {
      url: 'declaration',
      type: 'link',
    },
    'Static Documents': {
      url: 'documents',
      type: 'link',
    },
    'Dynamic Documents': {
      url: 'dynamic-documents',
      type: 'link',
    },
    'Document Pack': {
      url: 'document-pack',
      type: 'link',
    },
  },
  SL: {
    'Scheme Management': {
      url: 'schemes',
      type: 'link',
    },
    Definitions: {
      url: 'definitions',
      type: 'link',
    },
    Declaration: {
      url: 'declaration',
      type: 'link',
    },
    'Static Documents': {
      url: 'documents',
      type: 'link',
    },
    'Dynamic Documents': {
      url: 'dynamic-documents',
      type: 'link',
    },
    'Document Pack': {
      url: 'document-pack',
      type: 'link',
    },
  },
};

const ProductManagementListContainer = ({ getProductsList }) => {
  useEffect(
    () => {
      getProductsList();
    },
    [getProductsList],
  );

  const productList = useSelector((state) => state.productManagement.productList);

  if (!productList?.length) {
    return (
      <div className="admin-area product-container">
        <InternalContainer title="Product management">
          <Loader />
        </InternalContainer>
      </div>
    );
  }

  const productOrder = [
    'Leisure Travel',
    'Smart Luggage',
    'Cancer Cover',
    'Hospital Cash Plan',
    'Personal Accident',
    'Surgery Cash Plan',
  ];

  Array.isArray(productList)
    ? productList.sort((a, b) => {
        return (
          productOrder.indexOf(a.attributes.name) -
          productOrder.indexOf(b.attributes.name)
        );
      })
    : [];

  return (
    <div className="admin-area ">
      <InternalContainer title="Product management">
        <Box className={'dashboard-product-container animated fadeIn'}>
          {productList.map((product) => (
            <ProductListItem
              key={product.id}
              productId={product.id}
              productName={product.attributes.name}
              productCode={product.attributes.product_code}
              productDescription={product.attributes.description}
              product={product}
              buttons={ALLOWED_BUTTONS[product.attributes.product_code]}
            />
          ))}
        </Box>
      </InternalContainer>
    </div>
  );
};

export default connect(
  null,
  {
    getProductsList: actions.getProductsList,
  },
)(ProductManagementListContainer);
